import { Link, useRouteLoaderData } from '@remix-run/react';
import { APP } from '~/lib/constants';

export const Footer = () => {
  const rootData = useRouteLoaderData('root') as { currentYear?: number } | undefined;
  const startYear = 2026;
  const currentYear = rootData?.currentYear ?? startYear;
  const yearText = currentYear > startYear
    ? `${startYear} - ${currentYear}`
    : `${startYear}`;

  return (
    <div className="border-t border-slate-100 bg-slate-50 mt-6">
      <div className="container px-4 py-8 mx-auto">
        <div className={'text-sm text-slate-500 flex flex-col md:flex-row gap-4 justify-center items-center'}>
          <Link
            to={`/`}
            className={'hover:underline'}
          >
            Top
          </Link>
          <Link
            to={`/pricing`}
            className={'hover:underline'}
          >
            Pricing
          </Link>
          <Link
            to={`/terms`}
            className={'hover:underline'}
          >
            Terms of Service
          </Link>
          <Link
            to={`/privacy`}
            className={'hover:underline'}
          >
            Privacy Policy
          </Link>
          <Link
            to={APP.CONTACT_URL}
            className={'hover:underline'}
            target={'_blank'}
            rel="noreferrer"
          >
            Contact
          </Link>
          <Link
            to={`/specified-commercial-transactions`}
            className={'hover:underline'}
          >
            特定商取引法に基づく表記
          </Link>
        </div>

        <div className={'text-slate-400 mt-6 flex flex-col justify-center items-center gap-4 text-xs'}>
          © {yearText} Dewdrop
        </div>

      </div>
    </div>
  );
};
